<template>
    <div>
        <VerifyOwnership 
            :data = "data"
            @setData="setData"
        />
        
    </div>
</template>
<script>
import Heading from '../../../components/Theme/Heading'
import VerifyOwnership from '../../../components/Ecommerce/verifyOwnership'

export default {
    name: 'Step4',
    components: {
        Heading,
        VerifyOwnership
    },
    props: {
        data: Object
    },
    setup(props, {emit}){
        const setData = data => emit('setData', data)

        return {
            setData
        }
    }
}
</script>




